import type { ExplodeEvent } from "@core/systems/transport3d";
import type { EventHandler } from "@core/utils/pubsub";
import type { Engine3D } from "@ogl-engine/engine/engine3d";
import { ExplosionParticleGenerator } from "@ogl-engine/particles/explosion";

export function createExplodeHandler(
  engine: Engine3D
): EventHandler<ExplodeEvent> {
  return ({ entity }) => {
    const mesh = engine.getByEntityId(entity.id);
    if (mesh) {
      const explosion = new ExplosionParticleGenerator(engine!);
      explosion.scale.set(
        mesh.geometry.bounds.max.sub(mesh.geometry.bounds.min).len() / 2
      );
      explosion.setParent(engine.scene);
      explosion.position.copy(mesh.position);
    }
  };
}
